import { useTranslation } from 'react-i18next'
import TargetOverrideNote from './TargetOverrideNote'

const valueUnit = (x) => [x?.value ?? '—', x?.unit].filter(Boolean).join(' ')

// before/after of one `set_nutrition_target` operation: the value, who set it,
// and the computed value with its reason and conditions.
export function NutritionTargetChange({ operation }) {
  const { t } = useTranslation()
  const { before, after } = operation
  const conditions = after?.conditions ?? []
  return (
    <span className="grid grid-cols-1 sm:grid-cols-2 gap-1 mt-1 text-xs" data-testid="nutrition-target-change">
      <span className="text-gray-600">
        {t('healthCycle.changeSet.before')}: <span className="line-through">{valueUnit(before)}</span>
        {before?.source === 'user'
          ? <TargetOverrideNote target={before} />
          : <span className="block">{t('healthCycle.changeSet.computedByCode', { reason: t(`cycleReports.reasonCode.${before?.reason_code}`, before?.reason_code ?? '') })}</span>}
      </span>
      <span className="text-gray-900">
        {t('healthCycle.changeSet.after')}: {valueUnit(after)}
        <TargetOverrideNote target={after} />
        {conditions.map((c, i) => (
          <span key={i} className="block text-amber-700">
            {t(`cycleReports.condition.${c.code}`, {
              defaultValue: c.code, marker: c.marker ?? '', value: c.value ?? '',
              unlogged: c.unlogged_kcal_per_day ?? '',
              test: c.resolving_test ? t(`cycleReports.resolvingTest.${c.resolving_test}`, c.resolving_test) : '',
            })}
          </span>
        ))}
      </span>
    </span>
  )
}

export default NutritionTargetChange
